import { QueryClient, QueryCache } from "@tanstack/react-query";
import { bugsnagGeneralErrorHandler } from "../global_functions/postgrestApi";

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: bugsnagGeneralErrorHandler,
  }),
  defaultOptions: {
    mutations: {
      onError: bugsnagGeneralErrorHandler,
    },
  },
});
